@import '../../scss/mixin';

.dictate {
  @include btn();
}
